import tablelistApi from 'api/tablelistApi';

export default {
  actionById(id, options = {}) {
    if (!id) throw new Error('id is required');
    if (!options) throw new Error('options is required');

    return tablelistApi.post(`/membership/${id}/action`, options);
  }
};



// WEBPACK FOOTER //
// ./src/api/membership/service.js